import React from "react";
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'

// react-bootstrap components
import {
    Button,
    Dropdown,
    Navbar,
    Nav,
    NavDropdown,
    Container,
} from "react-bootstrap";

function AdminNavbar() {
    const location = useLocation();
    const history = useHistory()

    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const isSideBarMini = useSelector((state) => state.isSideBarMini);

    const [collapseOpen, setCollapseOpen] = React.useState(false);

    return (
        <>
            <div className="d-block d-md-none">
            <Navbar expand="lg">
                <Container fluid>
                    <div className="navbar-wrapper">
                        <div className="navbar-minimize">
                            <Button
                                className="btn-fill btn-round btn-icon d-none d-lg-block bg-dark border-dark"
                                variant="dark"
                                onClick={() => { document.body.classList.toggle("sidebar-mini"); dispatch({ type: 'set', isSideBarMini: !isSideBarMini }); }}
                            >
                                <i className="fas fa-ellipsis-v visible-on-sidebar-regular"></i>
                                <i className="fas fa-bars visible-on-sidebar-mini"></i>
                            </Button>
                            <Button
                                className="btn-fill btn-round btn-icon d-block d-lg-none bg-dark border-dark"
                                variant="dark"
                                onClick={() =>
                                    document.documentElement.classList.toggle("nav-open")
                                }
                            >
                                <i className="fas fa-ellipsis-v visible-on-sidebar-regular"></i>
                                <i className="fas fa-bars visible-on-sidebar-mini"></i>
                            </Button>
                        </div>
                    </div>
                    {/*<button*/}
                    {/*    className="navbar-toggler navbar-toggler-right border-0"*/}
                    {/*    type="button"*/}
                    {/*    onClick={() => setCollapseOpen(!collapseOpen)}*/}
                    {/*>*/}
                    {/*    <span className="navbar-toggler-bar burger-lines"></span>*/}
                    {/*    <span className="navbar-toggler-bar burger-lines"></span>*/}
                    {/*    <span className="navbar-toggler-bar burger-lines"></span>*/}
                    {/*</button>*/}

                    {/*<Navbar.Collapse className="justify-content-end fpm-nav" in={collapseOpen}>*/}
                    {/*    <Nav className="me-auto">*/}
                    {/*        <Nav.Link href="#home">Home</Nav.Link>*/}
                    {/*        <Nav.Link href="#link">Link</Nav.Link>*/}
                    {/*        <NavDropdown title="Dropdown" id="basic-nav-dropdown">*/}
                    {/*            <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>*/}
                    {/*            <NavDropdown.Item href="#action/3.2">*/}
                    {/*                Another action*/}
                    {/*            </NavDropdown.Item>*/}
                    {/*            <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>*/}
                    {/*            <NavDropdown.Divider />*/}
                    {/*            <NavDropdown.Item href="#action/3.4">*/}
                    {/*                Separated link*/}
                    {/*            </NavDropdown.Item>*/}
                    {/*        </NavDropdown>*/}
                    {/*    </Nav>*/}
                    {/*</Navbar.Collapse>*/}
                </Container>
                </Navbar>
            </div>
        </>
    );
}

export default AdminNavbar;
